export default function video() {
    if (document.querySelector('.js--video')) {
        videoTrigger();
    }
}

function videoTrigger() {
    const videoContainers = document.querySelectorAll('.js--video');

    videoContainers.forEach(function(videoContainer) {
        let videoTrigger = videoContainer.querySelector('.video__svg');
        let video = videoContainer.querySelector('video');
        let backgroundImageContainer = videoContainer.querySelector('.video__poster');


        if(videoTrigger) {
            videoTrigger.addEventListener('click', function() {
                video.setAttribute('controls', '');
                video.play();
                videoTrigger.remove();

                // Remove the background image container from the DOM
                if (backgroundImageContainer) {
                    backgroundImageContainer.remove();
                }
            });
        }

    });
}